<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-button
        type="primary"
        size="small"
        @click="_modify(null)"
        v-if="canAdd"
        >添加</el-button
      >
      <!-- <el-button type="primary" size="small" @click="delSystemPeople">删除</el-button> -->
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="快递公司编码" />
        <el-table-column prop="fName" label="快递公司名称" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >編輯</el-button
              >
            </template>
            <template>
              <ConfirmButton v-if="canDel" @confirm="_delete(scope.row)"
                >删除</ConfirmButton
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import EditForm from "./EditForm";
import ConfirmButton from "@components/ConfirmButton";
export default {
  components: {
    EditForm,
    ConfirmButton,
  },
  data() {
    return {
      tableData: [],
      selectOptions: [],
      selectValue: "",
      loading: false,
      selectFid: "",
      selectArr: [],
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true,
    };
  },
  mounted() {
    this.refresh();
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key === "004012002") {
        this.canAdd = val.isGrant;
      }
      if (val.key === "004012003") {
        this.canEdit = val.isGrant;
      }
      if (val.key === "004012004") {
        this.canDel = val.isGrant;
      }
    });
  },
  methods: {
    // 获取快递公司列表
    refresh() {
      this.loading = true;
      this.$httpPost("BasicInformation/KdCompany/KdCompanyEntry", this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist;
          // this.pageRecordTotal = res.datalist.total;
        })
        .finally(() => (this.loading = false));
    },
    _modify: async function (row) {
      const isNew = !row;
      if (isNew) {
        this.currentEditItem = {
          fKdCompanyID: null,
          fNumber: null,
          fName: null,
          type: "按系统默认网址",
          fExpressInquiry: null,
          fCreateTime: null,
        };
      } else {
        this.currentEditItem = await this.$httpPost(
          "BasicInformation/KdCompany/GetKdCompany",
          { fid: row.fid }
        ).then((res) => res.datalist);
      }
      let or;
      if (isNew) {
        or = this.canAdd;
      } else {
        or = this.canEdit;
      }
      const h = this.$createElement;
      this.$formDlg({
        title: isNew ? "新建快递公司" : `修改快递公司`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: "40%",
        readonly: !or,
      });
    },
    async _delete(row) {
      this.currentEditItem = await this.$httpPost(
        "BasicInformation/KdCompany/GetKdCompany",
        { fid: row.fid }
      ).then((res) => res.datalist);
      this.postData(2, this.currentEditItem);
    },
    postData(modifyType, info) {
      return this.$httpPost(`BasicInformation/KdCompany/KdCompanyModify`, {
        datalist: JSON.stringify({
          modifyType,
          info,
        }),
      }).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
  },
};
</script>
<style lang="">
</style>
